

type filetype = 'excel' | 'pdf' | 'csv' | 'doc' | 'zip'

export const generateDownload = (file: any, fileName: string, type: filetype, open?: boolean): void => {
  const url = window.URL.createObjectURL(
    new Blob([file], { type: getType(type) })
  );
  const link = document.createElement("a");
  link.href = url;
  if (open)
    link.target = "_blank";
  else
    link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};



const getType = (type: filetype) => {

  switch (type) {
    case "excel":

      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

    case "csv":
      return "text/csv"

    case "doc":
      return "application/msword"

    case "zip":
      return "application/zip"

    default:
      return "application/pdf"
  }

}